import { render, staticRenderFns } from "./TabelaResultadosConvenios.vue?vue&type=template&id=5f5ba634&scoped=true&"
import script from "./TabelaResultadosConvenios.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosConvenios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5ba634",
  null
  
)

export default component.exports